import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 12c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M20 7H4v4.6794l4.0456-1.6086a1 1 0 0 1 1.0477.1944l3.3589 3.1005L20 11.5898zm0 6.6444-5.7741 1.3586L16.3894 17H20zM4 17v-3.1682l4.1995-1.6699L13.4407 17zM4 5c-1.1046 0-2 .8954-2 2v10c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V7c0-1.1046-.8954-2-2-2z",
        clipRule: "evenodd"
    }, "1")
], "CreativeImage", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
